import { createMandatoryContext } from '@change-corgi/core-react/context';

import type { UseBannerStateReturn } from './hook';

export const {
	Context: StarterDashboardV2BannerStateContext,
	Provider: StarterDashboardV2BannerStateContextProvider,
	useContext: useStarterDashboardV2BannerState,
} = createMandatoryContext<UseBannerStateReturn | undefined, UseBannerStateReturn>(undefined, {
	name: 'BannerStateContext',
	processProviderProps: ({ data, actions }) => ({ data, actions }),
});

export type StarterDashboardV2PageBannerState = ReturnType<typeof useStarterDashboardV2BannerState>;
